import React from "react";
import RegisterForm from "~/components/Forms/RegisterForm";

const RegisterPage: React.FC = () => {
    return <React.Fragment>
        <RegisterForm/>
    </React.Fragment>
}

export default RegisterPage;